const EXERCISE_CATEGORY_LABELS = {
    A1: 'Warmup & Activation',
    A2: 'Aerobic Resistance',
    B1: 'Anaerobic Threshold',
    B2: 'VO2 Max',
    C1: 'Lactate Tolerance',
    C2: 'Peak Lactate Tolerance',
    C3: 'Maximum Effort',
    Recovery: 'Recovery',
    Technique: 'Technique',
    Cooldown: 'Cooldown',
    Warmup: 'Warmup',
};

export const getExerciseCategoryLabel = (category) => {
    const normalized = typeof category === 'string' ? category.trim() : '';

    if (!normalized) {
        return 'Exercise';
    }

    return EXERCISE_CATEGORY_LABELS[normalized] || normalized;
};

export default EXERCISE_CATEGORY_LABELS;
